import React, { Component } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';

export class AddPO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrder: this.props.purchaseOrder || '',
      checkNumber: '',
      isSubmitting: false
    };
  }

  // Update state on input change for both fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // Common handler for both dealer and installer submissions
  handleSubmit = async (event) => {
    event.preventDefault();
    
    const { purchaseOrder, checkNumber } = this.state;
    const { type, onPO, onInvoice, requestId, invoiceId, onClose } = this.props;
    
    try {
      this.setState({ isSubmitting: true });

      // Step 1: Update the PO if it's changed and not empty
      if (purchaseOrder && purchaseOrder !== this.props.purchaseOrder) {
        await onPO(purchaseOrder);
      }
      
      // Step 2: For installers, also process the invoice with check number
      if (type === "installer") {
        await onInvoice(requestId, invoiceId, checkNumber);
      }
      
      // Close the modal on success
      onClose();
    } catch (error) {
      console.error("Error submitting form:", error);
      // You could add error handling here (e.g., show an error message)
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { type, purchaseOrder, show, onClose } = this.props;
    const { purchaseOrder: statePO, checkNumber, isSubmitting } = this.state;
    
    // Set modal title based on user type and whether a PO exists already
    let title = "Enter the PO #";
    let buttonText = "Add PO";
    
    if (type === "installer") {
      title = purchaseOrder
        ? "Enter the check # and close out invoice"
        : "Enter the PO and/or check # and close out invoice";
      buttonText = "Close Dealer Invoice";
    }

    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <Row>
              <Col sm={6}>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Group controlId="PurchaseOrder">
                    <Form.Label>PO #</Form.Label>
                    {!purchaseOrder ? (
                      <Form.Control
                        type="text"
                        name="purchaseOrder"
                        value={statePO}
                        onChange={this.handleChange}
                        required={type === "dealer"}
                        placeholder="This will store with the invoice"
                      />
                    ) : (
                      <div>{purchaseOrder}</div>
                    )}
                  </Form.Group>

                  {type === "installer" && (
                    <Form.Group controlId="CheckNumber">
                      <Form.Label>Check #</Form.Label>
                      <Form.Control
                        type="text"
                        name="checkNumber"
                        value={checkNumber}
                        onChange={this.handleChange}
                        placeholder="This will store with the payment"
                      />
                    </Form.Group>
                  )}

                  <Form.Group>
                    <Button
                      variant="primary"
                      onClick={this.handleSubmit}
                      className="buttons"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Processing..." : buttonText}
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}